import { Component, OnInit } from '@angular/core';
import { AndroidService, Downloads } from '../android/android.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { InitScripts } from '../app.constants';
import { MetamanagerService } from '../metamanager.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private androidService: AndroidService, private metaManager: MetamanagerService) {
  }

  ngOnInit(): void {
    this.metaManager.updateMetaTitle("Mahanubhav Panth | sarvadhnya.com",
      "Information about Mahanubhav Panth, Shri Chakradhar swami, Shri Dattatreya Prabhu, Shri Govind Prabhu, Shri Krushna, Shri Chakrapani Maharaj, panchakrushna, panchavatar, महानुभाव पंथ",
      "श्री कृष्ण चक्रवर्ती महाराज, श्री कृष्ण चक्रवर्ती, श्री कृष्ण, कृष्ण, श्री दत्तात्रेय प्रभू, श्री दत्तात्रेय, श्री दत्त, श्री चक्रपाणी महाराज, श्री चक्रपाणी, चक्रपाणी, श्री गोविंद प्रभू, श्री गोविंद, श्री प्रभू, श्री चक्रधर स्वामी, श्री चक्रधर, चक्रधर स्वामी, चक्रधर, Sarvadhnya.com, Mahanubhav, Mahanubhav panth, sarvadhnya, sarvadnya, dattatrey prabhu, chakradhar swami, govind prabhu, krishna");
    new InitScripts().loadScripts();

    this.androidService.get().subscribe(response => {
      this.downloads.next(response);
    })
  }

  downloads = new BehaviorSubject<Downloads>(new Downloads());
}
